import { Alerta, Botao, Col, Row, TipoAlerta, TipoBotao } from "@intechprev/componentes-web";
import React, { useEffect, useState } from "react";
import { LoadingComponent } from "../../../components";
import { WebEventoDocumentoEntidade } from "../../../entidades";
import { EventoService } from "../../../services";
import { ControlButton } from "./ControlButton";
import { Indicators } from "./Indicators";
import { Item } from "./Item";
import config from "./../../../config.json";
import { useHistory } from "react-router-dom";

interface IProps {
  oidEvento: number;
}

export const Slides: React.FC<IProps> = ({
  oidEvento
}) => {
  const history = useHistory();

  const [VisibilidadeModal, setVisibilidadeModal] = useState<boolean>(false);
  const [IndexSelecionado, setIndexSelecionado] = useState<number>(0);
  const [Documento, setDocumento] = useState<WebEventoDocumentoEntidade>(new WebEventoDocumentoEntidade());
  const [Documentos, setDocumentos] = useState<WebEventoDocumentoEntidade[]>([]);
  const [Erro, setErro] = useState<string>('');
  const [Loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        await CarregarDocumentos();
      } catch (e) {
        const err: any = e;
        const Error = err.response ? err.response.data : err;
        setErro(Error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  async function CarregarDocumentos() {
    setLoading(true);
    try {
      const Documentos = await EventoService.BuscarDocumentos(oidEvento);
      setDocumentos(Documentos);
      if (Documentos.length > 0) {
        setIndexSelecionado(0);
        setDocumento(Documentos[0]);
      }
    }
    catch (e) {
      const err: any = e;
      const Error = err.response ? err.response.data : err;
      setErro(Error);
    } finally {
      setLoading(false);
    }
  }

  function SelecionarDocumento(acao: "avancar" | "voltar") {
    let index = IndexSelecionado;
    switch (acao) {
      case "avancar":
        index++;
        break;
      case "voltar":
        index--;
        break;
    }
    if (index < 0)
      index = 0;
    if (index >= Documentos.length)
      index = (Documentos.length - 1);

    const Documento = Documentos[index];
    setIndexSelecionado(index);
    setDocumento(Documento);
  }

  return (
    <>
      {Loading && <LoadingComponent />}

      {!Loading && Erro && <Alerta tipo={TipoAlerta.danger} mensagem={Erro} />}

      {!Loading && !Erro && <>
        <div className={"carousel slide"} style={{ "background": "rgba(0,0,0,0.3)", "height": "450px" }}>
          <Indicators indexAtivo={IndexSelecionado} docs={Documentos} />
          <div className="carousel-inner d-flex align-content-center justify-content-center">
            {/* {Documentos.map((doc, index) => {
              return (
                <Item
                  documento={doc}
                  indexSelecionado={IndexSelecionado}
                  index={index}
                  key={index}
                />
              )
            })} */}
            {Documento && <Item
              documento={Documento}
              indexSelecionado={IndexSelecionado}
              index={IndexSelecionado}
            />}
          </div>
          {IndexSelecionado > 0 && <ControlButton type={"prev"} onClick={() => SelecionarDocumento("voltar")} />}
          {IndexSelecionado < (Documentos.length - 1) && <ControlButton type={"next"} onClick={() => SelecionarDocumento("avancar")} />}
        </div>

        <hr />

        <Row>
          <Col>
            <Botao
              titulo={"Visualizar Foto"}
              onClick={() => setVisibilidadeModal(true)}
              icone={"fas magnifying-glass"}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <Botao
              className={"mt-2"}
              titulo={"Voltar"}
              onClick={() => history.push(`/eventos/`)}
              usaLoading
            />
          </Col>
        </Row>
      </>}

      {/* <Modal
        onConfirm={() => setVisibilidadeModal(false)}
        onClose={() => setVisibilidadeModal(false)}
        titulo={Documento.TXT_TITULO}
        tituloBotaoFechar={"Fechar"}
        visivel={VisibilidadeModal}
      >
        <img className={"d-block w-100"} style={{ "width": "100%" }} src={Documento && `${config.apiUrl}/Evento/BaixarDocumento/${Documento.OID_EVENTO_DOCUMENTO}`} alt={Documento.TXT_NOME_FISICO} />
      </Modal> */}

      {VisibilidadeModal &&
        <div className="modal" role="dialog">
          <div className="modal-dialog modal-lg" style={{ "maxWidth": "80%", "maxHeight": "80vh" }}>
            <div className="modal-content">

              <div className="modal-header">
                {/* <h5 className="modal-title">{Documento.TXT_TITULO}</h5> */}
                <button className="close" data-dismiss="modal" aria-label="Close" onClick={() => setVisibilidadeModal(false)}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className={"modal-body"} style={{ "maxHeight": "80vh", "height": "80vh", "overflow": "scroll" }}>
                {IndexSelecionado > 0 && <ControlButton type={"prev"} onClick={() => SelecionarDocumento("voltar")} />}
                <img className={"d-block w-100"} style={{ "width": "100%", "height": "100%", "objectFit": "contain" }} src={Documento && `${config.apiUrl}/Evento/BaixarDocumento/${Documento.OID_EVENTO_DOCUMENTO}`} alt={Documento.TXT_NOME_FISICO} />
                {IndexSelecionado < (Documentos.length - 1) && <ControlButton type={"next"} onClick={() => SelecionarDocumento("avancar")} />}
              </div>

              <div className={"modal-footer"}>
                <Row>
                  <Col>
                    {IndexSelecionado > 0 &&
                      <Botao
                        titulo={"Voltar"}
                        onClick={() => SelecionarDocumento("voltar")}
                      />
                    }
                  </Col>

                  <Col>
                    {IndexSelecionado < (Documentos.length - 1) &&
                      <Botao
                        titulo={"Avancar"}
                        onClick={() => SelecionarDocumento("avancar")}
                      />
                    }
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Botao
                      titulo={"Fechar"}
                      tipo={TipoBotao.secondary}
                      onClick={() => setVisibilidadeModal(false)}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      }
    </>
  );

}